import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "universityselection",
  inputs: [
    {
      name: "university_opted",
      label: "University/College Name",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "university_city",
      label: "University/College City",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "course_type",
      label: "Course Type",
      type: InputType.CountedAutoComplete,
      minLength: 2,
      maxLength: 100,
      options: [
        "Graduate",
        "Undergraduate",
        "Postgraduate",
        "PhD",
        "Masters",
        "Diploma",
        "Certificate",
      ],
    },
    {
      name: "course_selected",
      label: "Course Selected",
      placeholder: "Mtech. in Artificial Intelligence",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: false,
    },
    {
      name: "specific_reason",
      label: "Reason to choose University",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 650,
      assistance: true,
      helpType: "reasons_for_university",
      inputDependencies: ["university_opted", "university_city"],
    },
    {
      name: "alumni",
      label: "Notable Alumni of University",
      type: InputType.CountedTextArea,
      minLength: 2,
      assistance: true,
      inputDependencies: ["university_opted", "university_city"],
      helpType: "notable_alumni",
      maxLength: 650,
    },
    {
      name: "placements",
      label: "Placements",
      placeholder: "100% placements",
      type: InputType.CountedTextArea,
      minLength: 2,
      assistance: true,
      inputDependencies: ["university_opted", "university_city"],
      helpType: "placements",

      maxLength: 650,
    },
    {
      name: "details",
      label: "University Details",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 600,
      // description:
      //   "Mention here if there is some other details of university opted",
      inputDependencies: ["university_opted", "university_city"],
      helpType: "university_details",
      assistance: true,
      required: true,
    },
  ],
};

export default formFields;
